export default "__VITE_ASSET__CyGWY9yH__"